module.exports = __webpack_public_path__ + "static/media/03.ae0d13b0.jpg";